// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C01 register: shared semantic surfaces, three financial cards, split statuses. */
.rcti-c01-dashboard .rcti-financial-summary {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-6);
  margin-top: var(--space-6);
}
.rcti-c01-dashboard .rcti-financial-card {
  min-height: 154px;
  padding: var(--space-6);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: none;
  background: var(--surface-primary);
}
.rcti-c01-dashboard .rcti-financial-card h2 {
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
}
.rcti-c01-dashboard .rcti-financial-card strong {
  font-family: var(--font-family-mono);
  font-size: var(--font-size-money-lg);
  font-weight: var(--font-weight-medium);
}
.rcti-c01-dashboard .rcti-financial-card svg {
  color: var(--interactive-default);
  width: 20px;
  height: 20px;
}
.rcti-c01-dashboard .rcti-summary-note {
  grid-column: 1 / -1;
  margin: 0;
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.rcti-c01-dashboard .rcti-status-tabs {
  border-bottom: 1px solid var(--border-default);
  gap: var(--space-3);
}
.rcti-c01-dashboard .rcti-status-tabs button {
  font-size: var(--font-size-body-sm);
  padding: var(--space-3) var(--space-4);
}
.rcti-c01-dashboard .document-status-tabs > button:not(.is-active):not(:disabled) {
  color: var(--text-primary);
}
.rcti-c01-dashboard .document-status-tabs > button:not(.is-active):not(:disabled):hover {
  color: var(--text-secondary);
}
.rcti-c01-dashboard .rcti-list-filter-row {
  margin-top: 0;
  padding-block: var(--space-4) var(--space-6);
  gap: var(--space-3);
}
.rcti-c01-dashboard .rcti-list-search {
  width: 420px;
  max-width: 42%;
  margin: 0 !important;
}
.rcti-c01-dashboard .rcti-list-search:hover,
.rcti-c01-dashboard .rcti-filter-select .quotation-figma-dropdown-trigger:hover {
  border-color: var(--border-strong);
}
.rcti-c01-dashboard .rcti-list-search:focus-within {
  border-color: var(--interactive-default);
}
.rcti-c01-dashboard .rcti-filter-select .quotation-figma-dropdown-trigger:focus-visible,
.rcti-c01-dashboard .rcti-filter-select .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger {
  border: 1px solid var(--interactive-default);
  padding-inline: var(--space-3);
  box-shadow: none;
}
.rcti-c01-dashboard .rcti-list-search > button {
  display: none;
}
.rcti-c01-dashboard .rcti-list-search > .search-clear-button {
  display: inline-flex;
}
.rcti-c01-dashboard .rcti-filter-select {
  flex-basis: 160px;
  width: 160px;
  height: var(--control-md, 40px);
}
.rcti-c01-dashboard .rcti-due-select {
  flex-basis: 160px;
  width: 160px;
}
.rcti-c01-dashboard .quotation-clear-filters-action {
  flex-shrink: 0;
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.rcti-c01-dashboard .quotation-clear-filters-action:hover {
  border-color: var(--border-default);
  background: var(--surface-secondary);
}
.rcti-c01-dashboard .quotation-clear-filters-action:focus-visible {
  outline: 2px solid var(--interactive-default);
  outline-offset: 2px;
}
.rcti-c01-filter-count {
  margin-left: auto;
  white-space: nowrap;
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-c01-dashboard .rcti-table-card {
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: none;
  overflow: hidden;
}
.rcti-c01-dashboard .quotation-table-context {
  padding: var(--space-4);
  min-height: 52px;
  font-size: var(--font-size-body-sm);
}
.rcti-c01-dashboard .rcti-register-table table {
  width: 100%;
  min-width: 1040px;
  table-layout: fixed;
  border-collapse: collapse;
}
.rcti-c01-dashboard .rcti-register-table th {
  height: 44px;
  background: var(--surface-secondary);
  color: var(--text-secondary);
  padding: 0 12px;
  font-size: var(--font-size-caption-md);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
}
.rcti-c01-dashboard .rcti-register-table th:nth-child(1),
.rcti-c01-dashboard .rcti-register-table td:nth-child(1) {
  width: 15%;
}
.rcti-c01-dashboard .rcti-register-table th:nth-child(2),
.rcti-c01-dashboard .rcti-register-table td:nth-child(2) {
  width: 18%;
}
.rcti-c01-dashboard .rcti-register-table th:nth-child(3),
.rcti-c01-dashboard .rcti-register-table td:nth-child(3) {
  width: 14%;
}
.rcti-c01-dashboard .rcti-register-table th:nth-child(4),
.rcti-c01-dashboard .rcti-register-table td:nth-child(4) {
  width: 14%;
}
.rcti-c01-dashboard .rcti-register-table th:nth-child(5),
.rcti-c01-dashboard .rcti-register-table td:nth-child(5) {
  width: 12%;
}
.rcti-c01-dashboard .rcti-register-table th:nth-child(6),
.rcti-c01-dashboard .rcti-register-table td:nth-child(6) {
  width: 10%;
}
.rcti-c01-dashboard .rcti-register-table th:nth-child(7),
.rcti-c01-dashboard .rcti-register-table td:nth-child(7) {
  width: 10%;
}
.rcti-c01-dashboard .rcti-register-table th:last-child,
.rcti-c01-dashboard .rcti-register-table td.rcti-c01-actions {
  width: 7%;
  min-width: 72px;
  text-align: right;
  white-space: nowrap;
}
.rcti-c01-dashboard .rcti-register-table td.rcti-c01-actions .rcti-row-actions {
  justify-content: flex-end;
}
.rcti-c01-dashboard .rcti-register-table td {
  padding: 8px 12px;
  height: 52px;
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
  vertical-align: middle;
  border-top: 1px solid var(--border-default);
  border-bottom: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}
.rcti-c01-dashboard .rcti-register-table td small {
  display: block;
  margin-top: 3px;
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
  line-height: 1.35;
}
.rcti-c01-dashboard .rcti-register-table time {
  font-weight: var(--font-weight-medium);
}
.rcti-c01-dashboard .rcti-register-table .rcti-table-money {
  text-align: right;
  white-space: nowrap;
}
.rcti-c01-dashboard .rcti-register-table .rcti-table-money {
  font-family: var(--font-family-mono);
  font-size: var(--font-size-money-sm);
}
.rcti-c01-dashboard .rcti-register-table .quotation-mono-link {
  font-family: var(--font-family-mono);
  white-space: nowrap;
}
.rcti-c01-dashboard .rcti-register-table td:nth-child(2) {
  white-space: normal;
  overflow-wrap: anywhere;
}
.rcti-c01-dashboard .rcti-register-table td:nth-child(3) small,
.rcti-c01-dashboard .rcti-register-table td:nth-child(4) small,
.rcti-c01-dashboard .rcti-register-table td:nth-child(5) small {
  white-space: nowrap;
}
.rcti-c01-dashboard .rcti-register-table th.rcti-heading-money,
.rcti-c01-dashboard .rcti-register-table th.rcti-heading-money .rcti-sort-heading {
  text-align: right;
}
.rcti-c01-dashboard .rcti-register-table .rcti-sort-heading {
  width: 100%;
  white-space: nowrap;
}
.rcti-c01-dashboard .rcti-contact-link {
  font-size: inherit;
  color: var(--text-primary);
  font-weight: var(--font-weight-regular);
}
.rcti-c01-row-action {
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
}
.rcti-c01-row-action:hover {
  text-decoration: underline;
}
.rcti-c01-dashboard .rcti-status-pill {
  display: inline-flex;
  padding: 2px 7px;
  border-radius: var(--radius-pill);
  font-size: var(--font-size-caption-md);
  font-weight: var(--font-weight-medium);
  line-height: 1.4;
  white-space: nowrap;
}
.rcti-c01-dashboard .rcti-document-issued {
  background: var(--interactive-soft);
  color: var(--interactive-default);
}
.rcti-c01-dashboard .rcti-document-draft,
.rcti-c01-dashboard .rcti-document-voided,
.rcti-c01-dashboard .rcti-payment-not-payable {
  background: var(--surface-tertiary);
  color: var(--text-secondary);
}
.rcti-c01-dashboard .rcti-payment-overdue {
  background: var(--danger-soft);
  color: var(--danger-text);
}
.rcti-c01-dashboard .rcti-payment-part-paid,
.rcti-c01-dashboard .rcti-payment-unpaid {
  background: var(--warning-soft);
  color: var(--warning-text);
}
.rcti-c01-dashboard .rcti-payment-paid {
  background: var(--success-soft);
  color: var(--success-text);
}
.rcti-c01-dashboard .quotation-pagination {
  border-top: 1px solid var(--border-default);
  padding: var(--space-4);
  font-size: var(--font-size-body-sm);
}
.rcti-c01-footer-note {
  margin: var(--space-6) 0 0;
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.rcti-c01-load-error {
  display: flex;
  gap: var(--space-4);
  justify-content: space-between;
  padding: var(--space-4);
  border: 1px solid var(--danger-border);
  background: var(--danger-soft);
  color: var(--danger-text);
  border-radius: var(--radius-md);
}
.rcti-c01-load-error button {
  font: inherit;
  color: var(--text-primary);
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding-inline: var(--space-3);
  cursor: pointer;
}
@media (max-width: 1023px) {
  .rcti-c01-dashboard .rcti-financial-summary {
    gap: var(--space-4);
  }
  .rcti-c01-dashboard .rcti-financial-card {
    padding: var(--space-4);
  }
  .rcti-c01-dashboard .rcti-financial-card h2 {
    font-size: var(--font-size-body-md);
  }
  .rcti-c01-dashboard .rcti-list-search {
    max-width: none;
    width: 100%;
  }
  .rcti-c01-filter-count {
    margin-left: 0;
  }
}
@media (max-width: 600px) {
  .rcti-c01-dashboard .rcti-financial-summary {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-c01-dashboard .rcti-financial-card {
    min-height: 136px;
  }
  .rcti-c01-dashboard .rcti-filter-select,
  .rcti-c01-dashboard .rcti-due-select {
    flex: 1 1 150px;
    width: auto;
  }
  .rcti-c01-dashboard .quotation-table-context {
    flex-wrap: wrap;
    gap: var(--space-2);
  }
  .rcti-c01-dashboard .rcti-register-mobile-card > p {
    font-size: var(--font-size-body-sm);
    color: var(--text-secondary);
  }
  .rcti-c01-dashboard .rcti-mobile-financials {
    grid-template-columns: 1fr 1fr;
  }
  .rcti-c01-dashboard .rcti-register-mobile-card > .rcti-c01-row-action {
    display: inline-block;
    margin-top: var(--space-4);
  }
}

.rcti-c01-dashboard .rcti-register-table td:nth-child(3) small {
  white-space: nowrap;
  font-size: var(--font-size-caption-sm);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiDashboard.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE,gDAAgD;EAChD,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,wCAAwC;AAC1C;AACA;;EAEE,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;AACA;;;EAGE,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;EACtC,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,mCAAmC;IACnC,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC","sourcesContent":["/* C01 register: shared semantic surfaces, three financial cards, split statuses. */\n.rcti-c01-dashboard .rcti-financial-summary {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-6);\n  margin-top: var(--space-6);\n}\n.rcti-c01-dashboard .rcti-financial-card {\n  min-height: 154px;\n  padding: var(--space-6);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  box-shadow: none;\n  background: var(--surface-primary);\n}\n.rcti-c01-dashboard .rcti-financial-card h2 {\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-c01-dashboard .rcti-financial-card strong {\n  font-family: var(--font-family-mono);\n  font-size: var(--font-size-money-lg);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-c01-dashboard .rcti-financial-card svg {\n  color: var(--interactive-default);\n  width: 20px;\n  height: 20px;\n}\n.rcti-c01-dashboard .rcti-summary-note {\n  grid-column: 1 / -1;\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.rcti-c01-dashboard .rcti-status-tabs {\n  border-bottom: 1px solid var(--border-default);\n  gap: var(--space-3);\n}\n.rcti-c01-dashboard .rcti-status-tabs button {\n  font-size: var(--font-size-body-sm);\n  padding: var(--space-3) var(--space-4);\n}\n.rcti-c01-dashboard .document-status-tabs > button:not(.is-active):not(:disabled) {\n  color: var(--text-primary);\n}\n.rcti-c01-dashboard .document-status-tabs > button:not(.is-active):not(:disabled):hover {\n  color: var(--text-secondary);\n}\n.rcti-c01-dashboard .rcti-list-filter-row {\n  margin-top: 0;\n  padding-block: var(--space-4) var(--space-6);\n  gap: var(--space-3);\n}\n.rcti-c01-dashboard .rcti-list-search {\n  width: 420px;\n  max-width: 42%;\n  margin: 0 !important;\n}\n.rcti-c01-dashboard .rcti-list-search:hover,\n.rcti-c01-dashboard .rcti-filter-select .quotation-figma-dropdown-trigger:hover {\n  border-color: var(--border-strong);\n}\n.rcti-c01-dashboard .rcti-list-search:focus-within {\n  border-color: var(--interactive-default);\n}\n.rcti-c01-dashboard .rcti-filter-select .quotation-figma-dropdown-trigger:focus-visible,\n.rcti-c01-dashboard .rcti-filter-select .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger {\n  border: 1px solid var(--interactive-default);\n  padding-inline: var(--space-3);\n  box-shadow: none;\n}\n.rcti-c01-dashboard .rcti-list-search > button {\n  display: none;\n}\n.rcti-c01-dashboard .rcti-list-search > .search-clear-button {\n  display: inline-flex;\n}\n.rcti-c01-dashboard .rcti-filter-select {\n  flex-basis: 160px;\n  width: 160px;\n  height: var(--control-md, 40px);\n}\n.rcti-c01-dashboard .rcti-due-select {\n  flex-basis: 160px;\n  width: 160px;\n}\n.rcti-c01-dashboard .quotation-clear-filters-action {\n  flex-shrink: 0;\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.rcti-c01-dashboard .quotation-clear-filters-action:hover {\n  border-color: var(--border-default);\n  background: var(--surface-secondary);\n}\n.rcti-c01-dashboard .quotation-clear-filters-action:focus-visible {\n  outline: 2px solid var(--interactive-default);\n  outline-offset: 2px;\n}\n.rcti-c01-filter-count {\n  margin-left: auto;\n  white-space: nowrap;\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c01-dashboard .rcti-table-card {\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  box-shadow: none;\n  overflow: hidden;\n}\n.rcti-c01-dashboard .quotation-table-context {\n  padding: var(--space-4);\n  min-height: 52px;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c01-dashboard .rcti-register-table table {\n  width: 100%;\n  min-width: 1040px;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n.rcti-c01-dashboard .rcti-register-table th {\n  height: 44px;\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n  padding: 0 12px;\n  font-size: var(--font-size-caption-md);\n  font-weight: var(--font-weight-medium);\n  white-space: nowrap;\n  text-align: left;\n  vertical-align: middle;\n}\n.rcti-c01-dashboard .rcti-register-table th:nth-child(1),\n.rcti-c01-dashboard .rcti-register-table td:nth-child(1) {\n  width: 15%;\n}\n.rcti-c01-dashboard .rcti-register-table th:nth-child(2),\n.rcti-c01-dashboard .rcti-register-table td:nth-child(2) {\n  width: 18%;\n}\n.rcti-c01-dashboard .rcti-register-table th:nth-child(3),\n.rcti-c01-dashboard .rcti-register-table td:nth-child(3) {\n  width: 14%;\n}\n.rcti-c01-dashboard .rcti-register-table th:nth-child(4),\n.rcti-c01-dashboard .rcti-register-table td:nth-child(4) {\n  width: 14%;\n}\n.rcti-c01-dashboard .rcti-register-table th:nth-child(5),\n.rcti-c01-dashboard .rcti-register-table td:nth-child(5) {\n  width: 12%;\n}\n.rcti-c01-dashboard .rcti-register-table th:nth-child(6),\n.rcti-c01-dashboard .rcti-register-table td:nth-child(6) {\n  width: 10%;\n}\n.rcti-c01-dashboard .rcti-register-table th:nth-child(7),\n.rcti-c01-dashboard .rcti-register-table td:nth-child(7) {\n  width: 10%;\n}\n.rcti-c01-dashboard .rcti-register-table th:last-child,\n.rcti-c01-dashboard .rcti-register-table td.rcti-c01-actions {\n  width: 7%;\n  min-width: 72px;\n  text-align: right;\n  white-space: nowrap;\n}\n.rcti-c01-dashboard .rcti-register-table td.rcti-c01-actions .rcti-row-actions {\n  justify-content: flex-end;\n}\n.rcti-c01-dashboard .rcti-register-table td {\n  padding: 8px 12px;\n  height: 52px;\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n  vertical-align: middle;\n  border-top: 1px solid var(--border-default);\n  border-bottom: 0;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.rcti-c01-dashboard .rcti-register-table td small {\n  display: block;\n  margin-top: 3px;\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n  line-height: 1.35;\n}\n.rcti-c01-dashboard .rcti-register-table time {\n  font-weight: var(--font-weight-medium);\n}\n.rcti-c01-dashboard .rcti-register-table .rcti-table-money {\n  text-align: right;\n  white-space: nowrap;\n}\n.rcti-c01-dashboard .rcti-register-table .rcti-table-money {\n  font-family: var(--font-family-mono);\n  font-size: var(--font-size-money-sm);\n}\n.rcti-c01-dashboard .rcti-register-table .quotation-mono-link {\n  font-family: var(--font-family-mono);\n  white-space: nowrap;\n}\n.rcti-c01-dashboard .rcti-register-table td:nth-child(2) {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.rcti-c01-dashboard .rcti-register-table td:nth-child(3) small,\n.rcti-c01-dashboard .rcti-register-table td:nth-child(4) small,\n.rcti-c01-dashboard .rcti-register-table td:nth-child(5) small {\n  white-space: nowrap;\n}\n.rcti-c01-dashboard .rcti-register-table th.rcti-heading-money,\n.rcti-c01-dashboard .rcti-register-table th.rcti-heading-money .rcti-sort-heading {\n  text-align: right;\n}\n.rcti-c01-dashboard .rcti-register-table .rcti-sort-heading {\n  width: 100%;\n  white-space: nowrap;\n}\n.rcti-c01-dashboard .rcti-contact-link {\n  font-size: inherit;\n  color: var(--text-primary);\n  font-weight: var(--font-weight-regular);\n}\n.rcti-c01-row-action {\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n}\n.rcti-c01-row-action:hover {\n  text-decoration: underline;\n}\n.rcti-c01-dashboard .rcti-status-pill {\n  display: inline-flex;\n  padding: 2px 7px;\n  border-radius: var(--radius-pill);\n  font-size: var(--font-size-caption-md);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.4;\n  white-space: nowrap;\n}\n.rcti-c01-dashboard .rcti-document-issued {\n  background: var(--interactive-soft);\n  color: var(--interactive-default);\n}\n.rcti-c01-dashboard .rcti-document-draft,\n.rcti-c01-dashboard .rcti-document-voided,\n.rcti-c01-dashboard .rcti-payment-not-payable {\n  background: var(--surface-tertiary);\n  color: var(--text-secondary);\n}\n.rcti-c01-dashboard .rcti-payment-overdue {\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n.rcti-c01-dashboard .rcti-payment-part-paid,\n.rcti-c01-dashboard .rcti-payment-unpaid {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n.rcti-c01-dashboard .rcti-payment-paid {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n.rcti-c01-dashboard .quotation-pagination {\n  border-top: 1px solid var(--border-default);\n  padding: var(--space-4);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-c01-footer-note {\n  margin: var(--space-6) 0 0;\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.rcti-c01-load-error {\n  display: flex;\n  gap: var(--space-4);\n  justify-content: space-between;\n  padding: var(--space-4);\n  border: 1px solid var(--danger-border);\n  background: var(--danger-soft);\n  color: var(--danger-text);\n  border-radius: var(--radius-md);\n}\n.rcti-c01-load-error button {\n  font: inherit;\n  color: var(--text-primary);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  padding-inline: var(--space-3);\n  cursor: pointer;\n}\n@media (max-width: 1023px) {\n  .rcti-c01-dashboard .rcti-financial-summary {\n    gap: var(--space-4);\n  }\n  .rcti-c01-dashboard .rcti-financial-card {\n    padding: var(--space-4);\n  }\n  .rcti-c01-dashboard .rcti-financial-card h2 {\n    font-size: var(--font-size-body-md);\n  }\n  .rcti-c01-dashboard .rcti-list-search {\n    max-width: none;\n    width: 100%;\n  }\n  .rcti-c01-filter-count {\n    margin-left: 0;\n  }\n}\n@media (max-width: 600px) {\n  .rcti-c01-dashboard .rcti-financial-summary {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-c01-dashboard .rcti-financial-card {\n    min-height: 136px;\n  }\n  .rcti-c01-dashboard .rcti-filter-select,\n  .rcti-c01-dashboard .rcti-due-select {\n    flex: 1 1 150px;\n    width: auto;\n  }\n  .rcti-c01-dashboard .quotation-table-context {\n    flex-wrap: wrap;\n    gap: var(--space-2);\n  }\n  .rcti-c01-dashboard .rcti-register-mobile-card > p {\n    font-size: var(--font-size-body-sm);\n    color: var(--text-secondary);\n  }\n  .rcti-c01-dashboard .rcti-mobile-financials {\n    grid-template-columns: 1fr 1fr;\n  }\n  .rcti-c01-dashboard .rcti-register-mobile-card > .rcti-c01-row-action {\n    display: inline-block;\n    margin-top: var(--space-4);\n  }\n}\n\n.rcti-c01-dashboard .rcti-register-table td:nth-child(3) small {\n  white-space: nowrap;\n  font-size: var(--font-size-caption-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
